import { AuthenticationDetails, CognitoUser, CognitoUserPool, CognitoUserAttribute } from "amazon-cognito-identity-js";

import * as AWS from "aws-sdk/global";
import * as STS from "aws-sdk/clients/sts";

export class CognitoHelper {
    getUser() {
        return this.getUserPool().getCurrentUser()
    }

    getSession(success, failure) {
        const user = this.getUser()

        if (user === null) {
            console.log('No user logged in')

            failure('No user logged in')

            return
        }

        user.getSession(function(error, session) {
            console.log('user.getSession')
            console.log(`e: ${error}`)
            console.log(`s: ${session}`)
            console.log(session)

            if (error) {
                failure(error)
            } else {
                success(session)
            }
        })
    }

    getUserPool() {
        if (this.cognitoUserPool === undefined) {
            this.cognitoUserPool = new CognitoUserPool({
                UserPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
                ClientId: process.env.REACT_APP_COGNITO_USER_POOL_APP_CLIENT_ID
            })
        }

        return this.cognitoUserPool
    }

    getIdToken(forceRefresh) {
        const user = this.getUser()

        return new Promise(function(resolve) {
            user.getSession(function(session) {
                if (forceRefresh) {
                    session.refreshSessionIfPossible()
                        .then(function() {
                            resolve(session.getAccessToken().getJwtToken())
                        })
                } else {
                    resolve(session.getAccessToken().getJwtToken())
                }
            }, function(error) {
                console.log('Error retrieving session token.')
                resolve(null)
            })
        })
    }

    signOut(callback) {
        this.getUser().signOut()
    }

    buildCognitoCreds(idTokenJwt) {
        let url = 'cognito-idp.' + process.env.REACT_APP_AMAZON_REGION + '.amazonaws.com/' + process.env.REACT_APP_COGNITO_USER_POOL_ID;

        let logins = {};

        logins[url] = idTokenJwt;

        let params = {
//            IdentityPoolId: CognitoUtil._IDENTITY_POOL_ID, /* required */
            Logins: logins
        };

        let serviceConfigs = {};
//        if (environment.cognito_identity_endpoint) {
//            serviceConfigs.endpoint = environment.cognito_identity_endpoint;
//        }

        let creds = new AWS.CognitoIdentityCredentials(params, serviceConfigs);
        // this.setCognitoCreds(creds);
        return creds;
    }

    signIn(username, password, success, failure) {
        const me = this

        console.log("UserLoginService: starting the authentication");

        let authenticationData = {
            Username: username,
            Password: password,
        };

        let authenticationDetails = new AuthenticationDetails(authenticationData);

        let userData = {
            Username: username,
            Pool: this.getUserPool()
        };

        console.log("UserLoginService: Params set...Authenticating the user");

        let cognitoUser = new CognitoUser(userData);

        console.log("UserLoginService: config is ")
        console.log(AWS.config);

        cognitoUser.authenticateUser(authenticationDetails, {
            newPasswordRequired: function (userAttributes, requiredAttributes) {
                failure("User needs to set password")
            },
            onSuccess: function(session) {
                console.log("In authenticateUser onSuccess callback");

                AWS.config.credentials = me.buildCognitoCreds(session.getIdToken().getJwtToken());

                let clientParams = {};

                // if (environment.sts_endpoint) {
                //     clientParams.endpoint = environment.sts_endpoint;
                // }

                cognitoUser.setSignInUserSession(session)

                let sts = new STS(clientParams);

                sts.getCallerIdentity(function (err, data) {
                    console.log("UserLoginService: Successfully set the AWS credentials");

                    success(cognitoUser)
                });
            },
            onFailure: function(error) {
                failure(error)
            }
        });
    }

    createUser(username, password, success, failure) {
        var attributeList = [];

        var dataEmail = {
            Name : 'email',
            Value : username
        };

        var attributeEmail = new CognitoUserAttribute(dataEmail);

        attributeList.push(attributeEmail);

        console.log('SIGNING UP')
        console.log(attributeList)

        this.getUserPool().signUp(username, password, attributeList, null, function(err, result) {
            if (err) {
                failure(err.message)
            } else {
                var cognitoUser = result.user;
                console.log('user name is ' + cognitoUser.getUsername());

                success(cognitoUser)
            }
        })
    }

    sendPasswordReset(username, success, error) {
        let userData = {
            Username: username,
            Pool: this.getUserPool()
        };

        let cognitoUser = new CognitoUser(userData);

        cognitoUser.forgotPassword({
            onSuccess: function (message) {
                console.log(`cognitoUser.forgotPassword: ${message}`)
                success()
            },
            onFailure: function (err) {
                error(err.message)
            }
        });
    }

    confirmPassword(username, code, newPassword, callback) {
        let userData = {
            Username: username,
            Pool: this.getUserPool()
        };

        let cognitoUser = new CognitoUser(userData);

        cognitoUser.confirmPassword(code, newPassword, callback, {});
    }
}
